const KlUBoxPadding = {
    beforeMount: (el: HTMLElement) => {
        const baseClass = 'kl-u-box-padding';
        el.classList.add(baseClass);
    },
};

export default KlUBoxPadding;
